import { render, staticRenderFns } from "./ColumnAnswer.vue?vue&type=template&id=4de182b7&scoped=true"
import script from "./ColumnAnswer.vue?vue&type=script&lang=js"
export * from "./ColumnAnswer.vue?vue&type=script&lang=js"
import style0 from "./ColumnAnswer.vue?vue&type=style&index=0&id=4de182b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de182b7",
  null
  
)

export default component.exports